module.exports = __webpack_public_path__ + "static/media/img4-200-200.7a0417da.webp";